<template>
  <div>
    <template v-if="searchBar">
      <div id="stickToTopDiv" class="sticky-top py-2">
        <div class="row">
          <div class="col-12 d-inline-flex" id="baseTableSearch">
            <!-- dropdown slot, creates a dropdown next to the search bar-->
            <slot name="dropdown"></slot>
            <el-input
              placeholder="Search"
              v-model="searchInput"
              prefix-icon="el-icon-search"
              clearable
            ></el-input>
          </div>
        </div>
      </div>
    </template>

    <card v-if="dataPerPage.length !== 0 || isLoading">
      <el-table
        :data="dataPerPage"
        :class="{ 'no-header': !header }"
        v-loading="isLoading"
        element-loading-text="Loading..."
        @sort-change="emitSort"
      >
        <slot name="table" />
      </el-table>
      <div class="row justify-content-center">
        <el-pagination
          background
          class="col-auto mt-3"
          hide-on-single-page
          @current-change="handleCurrentChange"
          layout="total, prev, pager, next"
          :current-page="getCurrentPage"
          :page-size="itemsPerPage"
          :total="filteredTable.length"
        />
      </div>
    </card>
    <el-card
      class="text-center"
      shadow="hover"
      v-else-if="dataPerPage.length === 0 && !isLoading"
    >
      <el-table
        :data="[]"
        :class="{ 'no-header': !header }"
        v-loading="isLoading"
        element-loading-text="Loading..."
      >
        <slot name="table" /> </el-table
    ></el-card>
  </div>
</template>
<script>
//const axios = require("axios");
const moment = require("moment");

export default {
  name: "base-table",
  data() {
    return {
      pageCount: 0,
      currentPage: 1,
      searchInput: "",
      projectId: "",
      language: "",
      filteredTable: this.data
    };
  },
  props: {
    fullData: {
      type: Array,
      default: () => []
    },
    currentPageSelected: {
      type: Number,
      default: 1
    },
    data: {
      type: Array,
      default: () => []
    },
    header: {
      type: Boolean,
      default: true
    },
    itemsPerPage: {
      type: Number,
      default: 10
    },
    searchBar: {
      type: Boolean,
      default: true
    },
    searchOptions: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    filterOptions: {
      type: Array,
      default: () => []
    },
    hasFiltering: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    this.currentPage = this.currentPageSelected;
    this.pageCount = Math.ceil(this.data.length / this.itemsPerPage);
    if (this.searchByDate) this.dateFilter = this.defaultDate();
  },
  computed: {
    categories() {
      return [...new Set(this.data.map(d => d[this.filterOptions[0]]))];
    },
    dataPerPage() {
      return this.filterTable();
    },
    getCurrentPage() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.currentPage = this.currentPageSelected;
      return this.currentPageSelected;
    }
  },
  watch: {
    currentPage: function() {
      this.$emit("pageChange", this.currentPage);
    },
    filteredTable() {
      this.$emit("filteredTable", this.filteredTable);
    },
    currentPageSelected: function() {
      this.currentPage = this.currentPageSelected;
    }
  },
  methods: {
    emitNewVersionSelected() {
      this.$emit("newVersionSelected");
    },
    emitSort: function(evt) {
      evt["id"] = this.tableId;
      this.$emit("sort-change", evt);
    },
    filterTable() {
      let toSearch = this.searchInput;
      this.filteredTable = this.data;

      function sanitizeString(str) {
        return str
          ? str
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toLowerCase()
              .trim()
          : "";
      }

      // if search is enabled, filter table
      if (toSearch !== "") {
        const searchSanitized = sanitizeString(toSearch);
        this.filteredTable = this.filteredTable.filter(tE => {
          // sanitize strings
          return Object.keys(tE).some(function(k) {
            this.$console("info",k);
            return sanitizeString(tE[k]).includes(searchSanitized);
          });
          /*const sanitizedUID = sanitizeString(tE.uid);
          const sanitizedContract = sanitizeString(tE.contract_id);
          const sanitizedCountryCode = sanitizeString(tE.country_code);
          const sanitizedValid = sanitizeString(tE.valid.toString());
          const sanitizedSearch = sanitizeString(toSearch);

          return (
            sanitizedUID.includes(sanitizedSearch) ||
            sanitizedContract.includes(sanitizedSearch) ||
            sanitizedCountryCode.includes(sanitizedSearch) ||
            sanitizedValid.includes(sanitizedSearch)
          );*/
        });
      }

      // pagination of the data
      // doesnt work well when searching for id
      // --- maybe because the search runs through all the pages and
      // --- handlePagination cant keep up with the page number
      if (this.filteredTable.length < this.itemsPerPage + 1) {
        return this.filteredTable;
      }

      return this.handlePagination(this.filteredTable);
    },
    handlePagination(tableData) {
      // pagination of the data
      const perChunk = this.itemsPerPage;
      this.$console("info","handlePagionation() currentPage -> ", this.currentPage);
      return tableData.filter((m, i) => {
        const chunkIndex = Math.floor(i / perChunk);
        return chunkIndex === this.currentPage - 1;
      });
    },
    handleCurrentChange: function(val) {
      this.currentPage = val;
    },
    returnGlobalIndex: function(index) {
      const globalIndex =
        this.currentPage * this.itemsPerPage + index - this.itemsPerPage;
      return globalIndex;
    },
    deleteByIndex: function(index) {
      const globalIndex = this.returnGlobalIndex(index);
      // remove from data
      this.data.splice(globalIndex, 1);
      return this.data;
    },
    filterRoomsData() {
      this.selectedTags.forEach(tag => {
        const splitTag = tag.split(":");
        const tempFilter = splitTag[0];
        const value = splitTag[1].trim();

        const filterObject = this.filters.filter(f => f.value === tempFilter);
        const filter = filterObject[0];

        if (filter.value === "Duration") {
          const valueObject = this.tags.filter(t => t.value === value);

          this.filteredTable = this.filteredTable.filter(stat => {
            //calcular a duration da conversa
            const createdAt = moment(stat.createTime.toDate());
            const endedAt = moment(stat.updateTime.toDate());

            const duration = endedAt.diff(createdAt, "minutes");

            // if there's no maximum, then its > 10 minutes
            if (!valueObject[0].max) {
              return duration >= valueObject[0].min;
            }

            return (
              duration >= valueObject[0].min && duration < valueObject[0].max
            );
          });
        } else {
          // == , so that '5' equals 5
          this.filteredTable = this.filteredTable.filter(room =>
            room[filter.filter].includes(value)
          );
        }
      });
    }
  }
};
</script>
<style>
.no-header .el-table__header-wrapper {
  display: none !important;
}
.clearFilter {
  position: absolute;
  top: 0;
  right: 0;
}
.closeButton {
  color: black;
}
.filterOptionsDiv {
  display: inline;
  position: relative;
}
.clearbutton {
  color: red !important;
}
.dateSearch {
  margin-right: 15px;
}

#autocomplete .el-input__prefix {
  left: 20px;
}

#autocomplete + .el-input__prefix {
  left: 5px;
}

#baseTableSearch .el-input__suffix {
  right: 20px;
}

#stickToTopDiv {
  background-color: transparent;
}

.no-padding {
  padding: 0px !important;
}

.el-autocomplete,
.el-input {
  padding-left: 0px !important;
}

.el-tabs {
  background-color: transparent;
}

/*.el-input__inner {
  padding-left: 15px !important;
}*/
</style>
